import React from 'react';
import * as util from '../other/util.js'

// Shows meta info about the planet (used in GalaxyBrowserView)
export default class PlanetAbstractView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let planet = this.props.planet;

        if (!planet) {
            return (<util.LoadingBar thing={planet} thingName="planet" />);
        }

        return (
            <div>
                <h2>Planet: {planet.name}</h2>
                <table className="generic-list">
                    <tbody>
                        <tr key={"owner"}>
                            <td>Owner</td>
                            <td>
                                <util.PlayerLink playerId={planet.owner_id} playerName={planet.owner_name} />
                            </td>
                        </tr>
                        <tr key={"solar_system_position"}>
                            <td>Orbital position</td>
                            <td>{planet.z}</td>
                        </tr>
                        <tr key={"solar_system"}>
                            <td>Solar system</td>
                            <td>{planet.x + " | " + planet.y}</td>
                        </tr>
                        <tr key={"planet_age"}>
                            <td>Age</td>
                            {
                                (planet.astro_info.dob >= 0)
                                    ? <td>{util.InGameTime.getAgeAsNiceString(planet.astro_info.dob)}</td>
                                    : <td><div className="link-button" onClick={() => {
                                        util.toastHandler.callback({
                                            content: "This planet is very strange! All readings indicate that it is only a couple of years in age. The whole solar system looks as if the planet hasn't been here long. Nothing to be done about it now ...",
                                            hint: "Added to our database! This information might be useful later.",
                                        });
                                    }}> {util.InGameTime.getAgeAsNiceString(planet.astro_info.dob)}
                                    </div></td>
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}
